/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneLabel/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneLabel({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne/TysiaSelectOneLabel",
  maxWidth = "calc(100% - 24px)",
  text,
  color,
  size,
  weight = "medium",
  marginRight = 0,
  marginTop = 0,
  marginBottom = 4,
  required
  
}) {
let dtTysiainputfieldColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputField.color.primary.base'
        })
let dtColorsRed600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.600'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaSelectOneLabel.Horizontal"
  data-view-path={viewPath}
 style={{'--mw-1-Z1MIrk0': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={text}
 color={color || dtTysiainputfieldColorPrimaryBase}
 size={size}
 weight={weight}
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 marginRight={marginRight}
 marginTop={marginTop}
 display="block"
 marginBottom={size === "small" ? marginBottom : "4px"}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="*"
 marginLeft={2}
 color={dtColorsRed600}
 opacity={required ? 1 : 0}
/>
</div>
{children}
</React.Fragment>)
}